import * as React from 'react';
import { BaseDropdownModalProps } from '../DropdownCommentsModal/DropdownCommentsModal';
import { ModelWithError } from '../../../../misc/api/apiTypes';
import { DropdownCommentTypes, ShouldDisplay } from '../DropdownCommentsModal/DropdownCommentsHelpers';
import { connect } from 'react-redux';
import { MainState } from '../../../../Core/reducers';
import { AuditModal } from '../../../../auditmodal/components/AuditModal';
import { useWebPortalLegacyClient } from '../../../../misc/api/WebPortalTokenClient';

interface ResetReviewCommentsModalProps extends BaseDropdownModalProps, ResetReviewCommentsModalOwnProps {
    
}

interface ResetReviewCommentsModalOwnProps {
    onClose: () => void;
    analysisSetId: string;
    isAnalysisSetLinked: boolean;
    selectedDropdownCommentType: DropdownCommentTypes;
}

const ResetReviewCommentsModal = ({ analysisSetId, selectedDropdownCommentType, onClose }: ResetReviewCommentsModalProps): JSX.Element => {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [err, setErr] = React.useState<string>();
    const legacyClient = useWebPortalLegacyClient();

    const resetOrStartReview = (auditAnnotation: string) => {
        return legacyClient.resetCoughAnalysisSetReview(analysisSetId, auditAnnotation);
    }

    const message = "This will reset the current review process for this analysis set.";
    const header = "Reset current analysis set review.";

    const shouldDisplay = ShouldDisplay(DropdownCommentTypes.ResetReview);
    const getMessage = () => {
        return (<><em><strong>Warning: </strong></em> {message}</>);
    }

    return (shouldDisplay(analysisSetId, selectedDropdownCommentType) ? < AuditModal warning={getMessage()} isSubmitting={loading} error={err} header={header } onClose = { onClose } onSubmit = {(form) => {
        setErr(null);
        if (!form.Annotation || !form.Annotation.trim()) {
            setErr("An annotation is required.");
            return;
        }

        setLoading(true);
        resetOrStartReview(form.Annotation.trim())
            .then(() => onClose())
            .catch((err: ModelWithError) => {
                setErr(err.Errors[0].Message);
            })
            .finally(() => {
                setLoading(false);
            });
    }} /> : null);
};

function mapStateToProps(state: MainState, ownProps: ResetReviewCommentsModalOwnProps): ResetReviewCommentsModalProps {
    return {
        analysisSetId: ownProps.analysisSetId,
        isAnalysisSetLinked: ownProps.isAnalysisSetLinked,
        selectedDropdownCommentType: ownProps.selectedDropdownCommentType,
        onClose: ownProps.onClose
    };
}

export default connect<ResetReviewCommentsModalProps, void, ResetReviewCommentsModalOwnProps>(mapStateToProps)(ResetReviewCommentsModal);
